<template>
  <div class="container">
    <div class="content">
      <div class="text">
        <p v-html="content"></p>
      </div>
      <div class="content_item" v-for="(item ,index) in courses" :key="index">
        <img class="badge_img" v-if="item.is_tejia" :src='kc7Img' alt="">
        <img class="content_img" :src='item.image' alt="">
        <div class="column">
          <div class="mid_title">{{item.course_name}}</div>
          <div class="rower">
            <div class="content_mid">
              
              <div class="mid_text">{{item.description}}</div>
            </div>
        <div class="content_right">
          <div class="content_right_num">
            <img class="content_right_num_icon" :src='kc6Img' alt="">
            <div class="content_right_num_text">{{item.virtual_study}}人学过</div> 
          </div>
          <div class="content_right_btn" @click="detail(item.url)">查看详情</div>
        </div>
      </div>
      </div>
      </div>
     
    </div>
      <div class="gmmask" v-if="!show" @click="showxz"></div>
      <div class="gmbox">
        <div class="gmxz" @click="showxz">购买须知<img :src="jtsrc"></div>
        <div class="gmyh" v-if="getactive.is_coupon==1&&coupon.coupon_id!=null">
          <div style="color: rgb(34,34,34);font-size: 12px;">使用优惠卷</div>
          <div v-if="coupon.use_type=='1'" class="moneyfont_chose"><span>-￥{{coupon.reduce}}</span><img class="iconimg" :src="choseImg" alt=""></div>
          <div v-if="coupon.use_type=='2'" class="moneyfont_chose"><span>{{coupon.discount}}</span>折优惠<img class="iconimg" :src="choseImg" alt=""></div> 
        </div>
      </div>
      
      <div class="gmxz-el" @click="showxz" v-if="!show">
          <div class="gmxz-title">购买须知</div>
          <div class="gmxz-cont">本产品为虚拟内容服务，一经购买成功，概不退款，请您理解。</div>
      </div>
      <div class="mobile-footer">
        <div class="price">
          <span>￥</span>{{coupon.pay_price}}</div>
        <div class="extra-info">
          <div class="yh-btn">限时优惠</div>
<!--          <div style="text-decoration:line-through;color: #AFACBE;font-size:12px">原价{{getactive.market_price}}元</div>-->
        </div>
        <div class="buy-btn" @click="buy">
          <div class="buy">马上报名</div>
        </div>
      </div>

    <div class="mask" v-if="ismask"  @click="toShare"></div>
      <div class="phoneBox" v-if="ismask">
        <div class="phoneTip">请输入购买信息</div>
        <div class="input">
            <input type="text" v-model="phone" id="phone" placeholder="请输入您的手机号" autocomplete="off">
        </div>
        <div class="button">
            <button class="active" @click="sureBuy">
                <span>确认购买</span>
            </button>
        </div>
      </div>
  </div>
  
</template>
<style lang="stylus" rel="stylesheet/stylus" scoped>
$rem = 100;
.column{
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  box-sizing: border-box;
  width: calc(100% - 120px) ;
}
.phoneBox{
  width:80%;
  height 300px;
  position:absolute;
  border-radius:20px;
  background-color:#ed2553;
  top:200px;
  left:10%;
  box-shadow: 2px 2px 8px #333333;
  font-size :24px;
  z-index:1000;
}
.phoneBox .input{
  height: 50px;
  width: 80%;
  margin :20px auto 0 auto;
}
.phoneBox .input input{
  border:0;
  border-bottom :1px solid #fff;
  width :100%;
  color :#FFF;
  outline: none;
  height :100%;
  background-color :transparent;
  font-size :20px;
}
.phoneBox .button{
  color :#FFF;
  width :60%;
  margin :30px auto 0 auto;
  height :50px;
}
.phoneBox .button button{
  color :#ed2553;
  width :100%;
  height :100%;
  border:0;
  font-size :20px;
  background-color :#FFF;
  font-weight:bold;
}
.phoneTip{
  width :100%;
  height :40px;
  font-size :18px;
  color :#FFF;
  font-weight:bold;
  padding-left :20px;
  margin-top 20px;
  border-left :5px solid #fff;
  line-height :40PX;
}
.rower{
  display: flex;
  flex-direction: row;
  height :60px;
}
.gmmask{
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.4);
  position: fixed;
  top: 0;
  left: 0;
}
.gmxz-el {
    width: 100%;
    height: 90px;
    background-color: #ffffff;
    position: fixed;
    bottom: 60px;
    left: 0;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
}
.gmxz-title {
    height: 30px;
    line-height: 30px;
    vertical-align: middle;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #E3E9EB;
}
.gmxz-cont {
    padding: 10px 15px;
    line-height: 20px;
    vertical-align: middle;
    font-size: 14px;
    color: rgb(34,34,34);
}
.gmbox{
  width: 100%;
  display: flex;
  flex-direction: row;
  position: fixed;
    bottom:60px;
    left: 0;
    height: 30px;
    align-items: center;
    line-height: 30px;
    background-color: #ffffff;
    
}
.gmxz{
    display: flex;
    width: 100px;
    height: 30px;
    font-size: 12px;
    justify-content: center;
    border-bottom: 0px;
    color: #000000;
    align-items: center;
    border: 1px solid #E3E9EB;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
}
.gmyh{
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding-left:8px;
  padding-right: 8px;
  align-items: center;
  color: rgb(34,34,34);
  font-size: 12px;
  border-top: 1px solid #E3E9EB;
   border-bottom: 1px solid #E3E9EB;
    border-right: 1px solid #E3E9EB;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
.gmxz img{
    width: 16px;
    height: 16px;
    margin-left: 6px;
}
.extra-info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mobile-footer {
    width: 100%;
    height: 60px;
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 1px solid #E3E9EB;
    justify-content: space-around;
    background-color: #FFF;
}
.price {
    font-size: 22px;
    font-weight: 700;
    line-height: 60px;
}
.price span {
    font-size: 16px;
    font-weight: 700;
    line-height: 60px;
}
.yh-btn {
    position: relative;
    width: 100px;
    height: 20px;
    color: #FFF;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    font-weight: 400;
    border-radius: 4px;
    margin-bottom: 6px;
    background-image: linear-gradient(to right, #6740F0 , #FE729F);
}
.buy-btn {
    position: relative;
    width: 120px;
    height: 40px;
    color: #FFF;
    text-align: center;
    line-height: 40px;
    margin-top: 10px;
    font-size: 18px;
    font-weight: 400;
    border-radius: 4px;
    background-image: linear-gradient(to right, #6740F0 , #FE729F);
}


.icon_img{
  width: calc(100% -30px);
  max-height: 50px;
  height: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 15px;
  border-radius: 5px;
}
.container{
  overflow-y: scroll;
  /* font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  background-color: #fff;
  color: rgb(34,34,34);
}
.mask{
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index:999;
}
.moneyBig{
  font-size: 18px;
  color: #B3212D;
}
.unmoneyBig{
  font-size: 18px;
  color: rgb(34,34,34);
}
.box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 15px;
  height: 38px;
  line-height: 38px;
  margin-top: 20px;
  background-color: #FFF;
  border-bottom:1px solid #e7e7e7;
  border-top:1px solid #e7e7e7;
}
.box1{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 15px;
  height: 48px;
  background-color: #FFF;
  align-items: center;
 }
.box_left{
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.box_left_text{
  font-size: 12px;
  flex: 1;
  color: rgb(34,34,34);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 18px;
}
.box_right{
  display: flex;
  align-items: center;
}
.moneyfont{
  font-size: 14px;
  margin-right: 5px;
}
.moneyfont_chose{
  font-size: 14px;
  margin-right: 5px;
  color: #B3212D;
}
.moneyfont_chose span{
  font-size: 14px;
  /* font-family: Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  
}
.iconimg{
  width: 16px;
  height: 16px;
  margin-left: 5px;
  margin-bottom: 2px;
}
.title{
  font-size: 16px;
  line-height: 25px;
  font-weight: bold;
  color: rgb(34,34,34);
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
}
.user{
  width: 100%;
  height: 70px;
  display: flex;
  position: relative;
  border-bottom:1px solid #e7e7e7;
}
.user_right{
  margin-left: 12px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  line-height: 20px;
}
.user_icon1{
      width: 250px;
    position: relative;
    right: -280px;
  transform: translateX(-50%);
  top:-40px
}
.user_icon{
  width: 200px;
  position: relative;
  right: -270px;
  transform: translateX(-50%);
  top:-40px
}
.font{
  font-size: 12px;
  color: rgb(34,34,34);
}
.text{
  line-height: 20px;
}

.bottom_content{
    background-color: #ffffff;
    /* position: absolute; */
    width: 100%;
    /* bottom: 0;
    left: 0; */
}
.bottom_content_text{
    font-size: 14px;
    color: #222;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 30px;
    font-weight: bold;

}
.bottom_content_btn{
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.btn{
    background-color: #b3212d;
    color: #fff;
    font-size: 14px;
    border-radius: 14px;
    padding: 5px 9px;
    margin-right: 15px;
}
.btn1{
  background-color: #b3212d;
  color: #fff;
  font-size: 14px;
  border-radius: 14px;
  padding: 5px 9px;
  margin-right: 15px;
  width: 60px;
  height: 18px;
  text-align: center;
  line-height: 18px;
}
.content{
  width: 100%;
  margin-bottom :50px;
  padding-bottom:50px;
}
.content_item{
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 90px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 15px;
  position: relative;
  display: flex;
  flex-direction: row;
}
.content_img{
  width: 150px;
  height: 100%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  flex: 7;
}
.content_mid{
  flex: 8;
  align-items: center;
    display: flex;
}
.content_right{
  flex: 5;
  display :flex;
  flex-direction :column;
  align-items: center;
  justify-content :flex-end;
}
.mid_title{
  font-weight: 600;
  font-size: 14px;
  color: rgb(34,34,34);
  margin-top :5px;
  margin-bottom: 5px;
  line-height: 24px;
 text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient: vertical;
}
.mid_text{
  font-size: 12px;
  color:#1b1243; 
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.content_right_btn{
  width:  (200 / $rem) rem;
    height: 25px;
    text-align: center;
    line-height: 25px;
    background-color: #B3212D;
    color: #fff;
    border-radius: 24px;
    font-size: 12px;
    margin-bottom 5px;
    margin-top :5px
}
.content_right_num{
  display :flex;
  flex-direction :row;
  justify-content :center;
  align-items :center
}
.content_right_num_icon{
  width :12px;
  height :12px;
  margin-right :2px;
}
.content_right_num_text{
  font-size: 12px;
  color: #879AA7;
  margin-top :1px;
}
.badge_img{
   width: 55px;
  height: 55px;
  position: absolute;
    right: -3px;
    top: -3px;
}
</style>

<script>
import { getActive,activeBuy,getSign} from '../apollo/apollo'
import wx from 'weixin-js-sdk';
import { MessageBox } from 'mint-ui';
export default {
  components: {
    
  },
  data() {
    return {
      shareImg:'./static/imgs/share.png',
      knowImg:'./static/imgs/know.png',
      jtsrc:'./static/imgs/jt.png',
      getactive:{},//活动详情
      content:'',//干货内容
      mask:true,
      courses:[],
      coupon:{},//优惠卷
      kc6Img:'./static/imgs/kc6.png',
      kc7Img:'./static/imgs/kc7.png',
      choseImg:'./static/imgs/chose.png',
      ischose:true,//是否选中
      params:{},//购买验证
      sign:{},//权限包
      ismask:false,
      show:true,
      activity_id:0,
      phone:''
    }
  },
  computed:{
    
  },
  created() {
    this.init()
  },
  mounted(){
 
  },
  methods: {
     //获取参数
      getQueryStringOne(name) {
            var url=JSON.stringify(window.location.href)
            // var url=JSON.stringify("https://screen.xiaoyima.work/index.html?activity_id=9&state=123#/active")
            url=url.replace('?','&')
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = url.substr(1).match(reg);
		    return r?unescape(decodeURIComponent(r[2])):null; 
        },
     getQueryVariable(variable){
          var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split("=");
              if(pair[0] == variable){return pair[1];}
          }
          return(false);
      },

    showxz(){
      this.show=!this.show
    },
    init(){
sessionStorage.setItem('isactivity','0');
      if(this.$store.state.isactive=='1'||sessionStorage.getItem('isactivity')=='1'){//从列表进入或者从课程返回
        sessionStorage.setItem('isactivity','0');
        this.$store.state.isactive='0'
        this.activity_id=sessionStorage.getItem('activity_id')*1
        this.initActive()
      }else{
        //从分享链接进去  
        if(sessionStorage.getItem('share')==null||sessionStorage.getItem('share')==''){
            sessionStorage.setItem('share','2')
            this.activity_id=this.getQueryStringOne('activity_id')*1
            sessionStorage.setItem('activity_id',this.activity_id)
            this.jump('./login')
        }else{
          sessionStorage.setItem('share','')
          this.activity_id=sessionStorage.getItem('activity_id')*1
          this.initActive()
        }  
      }
    },
    initActive(){
      getActive({activity_id:this.activity_id}).then(res=>{
          this.getactive=res.data.getActivity;
          this.content=this.getactive.content//内容
          this.courses=this.getactive.courses//课程
          this.coupon=this.getactive.coupon//红包
          document.title=this.getactive.title;//标题
          this.phone = this.getactive.phone
          this.getAuthority()
          })
          .catch(err=>{
            this.msgManage(err)
          })
    },
    //获取权限包
    getAuthority(){
      var code=sessionStorage.getItem('code')
      var user_id=sessionStorage.getItem('user_id')
      getSign({url:window.location.href.split("#")[0]}).then(res=>{
        let that = this;
        that.Sign=res.data.getSign
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: that.Sign.appId, // 必填，公众号的唯一标识
            timestamp: that.Sign.timestamp, // 必填，生成签名的时间戳
            nonceStr:that.Sign.nonceStr, // 必填，生成签名的随机串
            signature:that.Sign.signature, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay','updateAppMessageShareData','updateTimelineShareData']
        });

          wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
            var data={
              title:that.getactive.title, // 分享标题
              desc:that.getactive.desc, // 分享描述
              link: 'https://screen.xiaoyima.work/index.html?'+'&activity_id='+that.activity_id+'&state=123'+'#/active', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:that.getactive.img_url, // 分享图标
            }
            wx.updateAppMessageShareData(data)
            wx.updateTimelineShareData(data)
          });
        })
        .catch(err=>{
           this.msgManage(err)
        })
    },
    //查看详情
    detail(url){
      sessionStorage.setItem('isactivity','1');
      window.location.href=url
    },
   chose(){
      this.ischose=!this.ischose
    },
    toShare(){
      this.ismask=false
    },
    buy(){
      MessageBox.confirm('是否确认购买','提示').then(action => {
        if(!this.phone){
            this.ismask = true;
            return
        }
        var formDate={
          activity_id:this.activity_id,//活动id
          price:this.getactive.price,
          pay_price:this.coupon.pay_price,
          coupon_user_id:this.coupon.coupon_user_id,
          coupon_id:this.coupon.coupon_id,
          phone:this.phone
        }
        activeBuy(formDate).then(res=>{
          if(JSON.parse(res.data.createActivityOrder).code==200){
            let that = this;
            this.params=JSON.parse(res.data.createActivityOrder).data
            wx.ready(function () {
              wx.chooseWXPay({
                appId:that.params.appId, //公众号名称，由商户传入
                timestamp:Number(that.params.timestamp), //时间戳，自1970年以来的秒数
                nonceStr:that.params.nonceStr, //随机串
                package:that.params.package,
                signType:that.params.signType, //微信签名方式：
                paySign:that.params.paySign,//微信签名
                complete:function(res){              
                  that.initActive()
                },
                success:function(res){
                  // that.initActive()
                  that.jump('./recordList')
                },
                error:function(res){
                  that.initActive()
                },
                cancel:function(res){
                  that.initActive()
                }
              });
            });
          }else{
            this.showOneBtnAlert(JSON.parse(res.data.createActivityOrder).msg)
          }
        })
        .catch(err=>{
            this.msgManage(err)
          })
      }).catch(()=>{   
           
        });
      
    },
    sureBuy(){
        if(!this.phone){
            this.showOneBtnAlert('请填写手机号')
            return
        }
        var formDate={
          activity_id:this.activity_id,//活动id
          price:this.getactive.price,
          pay_price:this.coupon.pay_price,
          coupon_user_id:this.coupon.coupon_user_id,
          coupon_id:this.coupon.coupon_id,
          phone:this.phone
        }
        this.ismask=false
        activeBuy(formDate).then(res=>{
          if(JSON.parse(res.data.createActivityOrder).code==200){
            let that = this;
            this.params=JSON.parse(res.data.createActivityOrder).data
            wx.ready(function () {
              wx.chooseWXPay({
                appId:that.params.appId, //公众号名称，由商户传入
                timestamp:Number(that.params.timestamp), //时间戳，自1970年以来的秒数
                nonceStr:that.params.nonceStr, //随机串
                package:that.params.package,
                signType:that.params.signType, //微信签名方式：
                paySign:that.params.paySign,//微信签名
                complete:function(res){              
                  that.initActive()
                },
                success:function(res){
                  // that.initActive()
                  that.jump('./recordList')
                },
                error:function(res){
                  that.initActive()
                },
                cancel:function(res){
                  that.initActive()
                }
              });
            });
          }else{
            this.showOneBtnAlert(JSON.parse(res.data.createActivityOrder).msg)
          }
        })
        .catch(err=>{
            this.msgManage(err)
          })
    }

  }, 
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/active.vue